module.exports = {"511827100":"穆坪镇","511827101":"灵关镇","511827102":"陇东镇","511827201":"蜂桶寨乡","511827202":"硗碛乡","511827203":"永富乡","511827204":"明礼乡","511827205":"五龙乡","511827206":"大溪乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511827.json
// module id = 2387
// module chunks = 0